

import { Box, Card, CardActionArea, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import React from 'react';
import { useEffect, useState } from 'react';
import { ClassesSubStatus, DaysSubStatus, FacultyCardDashCount, FetchBranchShowData, FetchSpecializationShowData, GetCourseShowData, GetSpecializationShowData, GetSubjectGraphShowData, LocationShowdata, PresentStatus, StudDashboardCount, StudentCardDashCount } from '../../services/LoginPageService';
import StudentDashModel from './StudentDashModel';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import ApplicationStore from '../../utils/localStorageUtil';

const StudentCardList = () => {
   const [location,setLocation] = useState('');
    const [locationList,setLocationList] = useState([]);
    const [branch,setBranch]=useState('');
    const [branchList,setBranchList]=useState([]);
    const [specialization,setSpecialization]=useState('');
    const [specializationList,setSpecializationList]=useState([]);
    const [subjectGraphList,setSubjectGraphList]=useState([]);
    const [subjectGraphListA,setSubjectGraphListA]=useState([]);

    const [refreshData, setRefreshData] = useState(false);
    const [semester, setSemester] = useState('');
    const [section, setSection] = useState('');
    const [totStudent,setTotStudent] = useState('');
    const [totPresent,setTotPresent] = useState('');
    const [totAbsent,setTotAbsent] = useState('');
    const [noOfHrsTkn,setHrsTaken] = useState('');
    const [totalHrs,setTotalHrs] = useState('');
    const [sectionId,setSectionId] = useState('');
    const [subjectId,setSubjectId] = useState('');
    const [key, setKey] = useState('');
    const [cardData,setCardData] = useState([]);
    const [dataSet,setDataSet] = useState([]);
    const [dataSets,setDataSets] = useState([]);
    const [chartData,setChartData] = useState([]);
    const [subClasses,setSubClasses] = useState([]);
    const [subDays,setDaysClasses] = useState([]);


    const [open, setOpen] = useState(false);
  const { user_token, userDetails } = ApplicationStore().getStorage('userDetails');
  const userRole = userDetails?.userRole; 

useEffect(() => {
  if (userRole === 'Faculty') {
    GetCourseShowData(handleCourseShow, handleCourseException);
  } else {
    LocationShowdata(handleLocationshow, handleLocationshowException);
  }
   
}, [refreshData]);

// Handlers for faculty
const handleCourseShow = (dataObject) => {
  setBranchList(dataObject?.data);
  console.log(dataObject?.data);
};

const handleCourseException = (errorStatus, errorMessage) => {
  console.log(errorMessage);
};

// Handlers for non-faculty
const handleLocationshow = (dataObject) => {
  setLocationList(dataObject?.data);
  console.log(dataObject?.data);
};

const handleLocationshowException = (error, errorMessage) => {
  console.log(errorMessage);
};

const onLocationChange = (e) => {
  setLocation(e.target.value);
  FetchBranchShowData({ id: e.target.value }, handleBranchSuccess, handleBranchException);
};

const handleBranchSuccess = (dataObject) => {
  setBranchList(dataObject.data);
};

const handleBranchException = (errorStatus, errorMessage) => {
  console.log(errorMessage);
};

const onBranchChange = (e) => {
  setBranch(e.target.value);
  if (userRole === 'Faculty') {
    GetSpecializationShowData({ id: e.target.value }, handleSpecializationSuccess, handleSpecializationException);
  } else {
    FetchSpecializationShowData({ id: e.target.value }, handleSpecializationSuccess, handleSpecializationException);
  }
 
};

const handleSpecializationSuccess = (dataObject) => {
  setSpecializationList(dataObject.data);
};

const handleSpecializationException = (errorStatus, errorMessage) => {
  console.log(errorMessage);
};



    const onSpecializationChange=(e)=>{
        setSpecialization(e.target.value);
        StudDashboardCount({ 
            location:location,
            branch : branch,
            sectionId:sectionId,
            specialization:e.target.value,
        },handleDashCountSuccess,handleDashCountException);
    }

    const handleDashCountSuccess=(dataObject)=>{
        setCardData(dataObject.data || []);
        setKey(keysArray);
    }

    const handleDashCountException=()=>{}
    
    const handleClickOpen = (card) => {
        console.log('open to sucess',card)
        setSectionId(card.sectionId);
        StudentCardDashCount({ sectionId:card.sectionId,},handleStudentCardDashCountSuccess,handleStudentCardDashCountException);
        setOpen(true);
        FacultyCardDashCount({ sectionId:card.sectionId,},handleFacultyCardDashCountSuccess,handleFacultyCardDashCountException);
        setOpen(true);
        PresentStatus({sectionId:card.sectionId,},handlePresentStatusSuccess,handlePresentStatusException);
        setOpen(true);
         GetSubjectGraphShowData({sectionId:card.sectionId,},handleSubjectGraphshow, handleSubjectGraphshowException);
        setOpen(true);
         ClassesSubStatus({sectionId:card.sectionId,subjectId:'All'},handleClassesStatusSuccess,handleClassesStatusException);
        setOpen(true);
        DaysSubStatus({sectionId:card.sectionId,subjectId:'All'},handleDaysStatusSuccess,handleDaysStatusException);
        setOpen(true);
    }
    
  const handleSubjectGraphshow = (dataObject) => {
    setSubjectGraphList(dataObject.data);
    setSubjectGraphListA(dataObject.data);

  };
  
  const handleSubjectGraphshowException = (errorStatus, errorMessage) => {
    console.log(errorMessage);
  };
    const handleStudentCardDashCountSuccess = (dataObject) =>{
        console.log('dataSet' , dataObject.data);
        setDataSet(dataObject.data || []);
        setRows(dataObject.data)
    }
    
    const handleStudentCardDashCountException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }
     const handlePresentStatusSuccess = (dataObject) =>{
        console.log('dataSet' , dataObject.data);
        setChartData(dataObject.data || []);
    }
    
    const handlePresentStatusException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }
const handleClassesStatusSuccess = (dataObject) =>{
        console.log('dataSet' , dataObject.data);
        setSubClasses(dataObject.data || []);
    }
    
    const handleClassesStatusException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }
    const handleDaysStatusSuccess = (dataObject) =>{
        console.log('dataSet' , dataObject.data);
        setDaysClasses(dataObject.data || []);
    }
    
    const handleDaysStatusException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }
    const handleFacultyCardDashCountSuccess = (dataObject) =>{
        console.log('dataSet' , dataObject.data);
        setDataSets(dataObject.data || []);
        setRows(dataObject.data)
    }
    
    const handleFacultyCardDashCountException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }
    
    const handleClose = () => {
        setOpen(false);
    };


    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
            {/* Filter Section */}
            <Grid container spacing={2} sx={{ p: 3, backgroundColor: 'white', boxShadow: 2 }}>
                {userRole !== 'Faculty' && (
                    <Grid item xs={12} sm={4} md={4} lg={4}>
                    <FormControl fullWidth>
                        <InputLabel id="location-select-label" sx={{ color: '#495057' }}>Location</InputLabel>
                        <Select
                            labelId="location-select-label"
                            id="location-select"
                            label="Location"
                            value={location}
                            onChange={(e) => onLocationChange(e)}
                            sx={{
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#adb5bd',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#6c757d',
                                },
                            }}
                        >
                            {locationList?.map((data, index) => (
                                <MenuItem value={data.id} key={index} sx={{ color: '#495057' }}>
                                    {data.location}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                )}
                
                <Grid item xs={12} sm={4} md={4} lg={4}>
                    <FormControl fullWidth>
                        <InputLabel id="course-select-label" sx={{ color: '#495057' }}>Hostel Name</InputLabel>
                        <Select
                            labelId="course-select-label"
                            id="course-select"
                            label="Hostel Name"
                            value={branch}
                            onChange={(e) => onBranchChange(e)}
                            sx={{
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#adb5bd',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#6c757d',
                                },
                            }}
                        >
                            {branchList.length !== 0 ? (
                                <MenuItem value="" sx={{ color: '#495057' }}><em>Select Hostel Name</em></MenuItem>
                            ) : (
                                <MenuItem value="" sx={{ color: '#495057' }}><em>Select Location</em></MenuItem>
                            )}
                            {branchList?.map((data, index) => (
                                <MenuItem value={data.id} key={index} sx={{ color: '#495057' }}>
                                    {data.branch}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4}>
                    <FormControl fullWidth>
                        <InputLabel id="specialization-select-label" sx={{ color: '#495057' }}>Specialization</InputLabel>
                        <Select
                            labelId="specialization-select-label"
                            id="specialization-select"
                            label="Specialization"
                            value={specialization}
                            onChange={(e) => onSpecializationChange(e)}
                            sx={{
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#adb5bd',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#6c757d',
                                },
                            }}
                        >
                            {specializationList.length !== 0 ? (
                                <MenuItem value="" sx={{ color: '#495057' }}><em>Select Specialization</em></MenuItem>
                            ) : (
                                <MenuItem value="" sx={{ color: '#495057' }}><em>Select Hostel Name</em></MenuItem>
                            )}
                            {specializationList?.map((data, index) => (
                                <MenuItem value={data.id} key={index} sx={{ color: '#495057' }}>
                                    {data.specialization}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            {/* Cards Section */}
            {/* <Grid container spacing={3} sx={{ p: 3 }}> */}
            <Grid container spacing={3} sx={{ p: 3, position: 'relative' }}>
                {cardData.map((card, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                        <Card
                            sx={{
                                borderRadius: '12px',
                                overflow: 'hidden',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                '&:hover': {
                                    transform: 'translateY(-5px)',
                                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.15)',
                                   
                                }
                            }}
                        >
                            <CardActionArea onClick={() => handleClickOpen(card)}>
                                {/* Card Header */}
                                <Box sx={{
                                    bgcolor:'#5d5d5d',
                                    p: 2,
                                    color: 'white'
                                }}>
                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                        <Typography variant="subtitle1" sx={{
                                            fontWeight: 600,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {card?.semester}
                                        </Typography>
                                        <Typography variant="h6" sx={{
                                            fontWeight: 700,
                                            color: '#00FFFF'
                                        }}>
                                            {card?.section}
                                        </Typography>
                                    </Stack>
                                </Box>

                                {/* Card Content */}
                                <Box sx={{
                                    bgcolor: 'white',
                                    p: 2
                                }}>
                                    {/* Hours Section */}
                                    <Grid container spacing={2} sx={{ mb: 2 }}>
                                       
                                         <Grid item xs={12}>
                                            <Box sx={{
                                                textAlign: 'center',
                                                p: 1,
                                                backgroundColor: '#e7f0faff',
                                                borderRadius: '8px'
                                            }}>
                                                <Typography variant="subtitle2" sx={{ color: '#298aebff' }}>
                                                    Students
                                                </Typography>
                                                <Typography variant="h6" sx={{
                                                    fontWeight: 600,
                                                    color: '#437eb9ff'
                                                }}>
                                                    {card?.totStudent || '0'}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                    {/* Students Section */}
                                    <Grid container spacing={1}>
                                       
                                        <Grid item xs={6}>
                                            <Box sx={{
                                                textAlign: 'center',
                                                p: 1,
                                                backgroundColor: '#e8f5e9',
                                                borderRadius: '8px'
                                            }}>
                                                <Typography variant="subtitle2" sx={{ color: '#2e7d32' }}>
                                                    Attendence
                                                </Typography>
                                                <Typography variant="h6" sx={{
                                                    fontWeight: 600,
                                                    color: '#2e7d32'
                                                }}>
                                                    {card?.totPresent || '0'}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Box sx={{
                                                textAlign: 'center',
                                                p: 1,
                                                backgroundColor: '#ffebee',
                                                borderRadius: '8px'
                                            }}>
                                                <Typography variant="subtitle2" sx={{ color: '#c62828' }}>
                                                    Absent
                                                </Typography>
                                                <Typography variant="h6" sx={{
                                                    fontWeight: 600,
                                                    color: '#c62828'
                                                }}>
                                                    {card?.totAbsent || '0'}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardActionArea>
                        </Card>
                     
                    </Grid>
                ))}
                 
            </Grid>


            {/* <StudentDashModel open={open} handleClose={handleClose} dataSet={dataSet} dataSets={dataSets} sectionId={sectionId} chartData={chartData} subjectGraphList={subjectGraphList} subClasses={subClasses} subjectGraphListA={subjectGraphListA} subDays={subDays}/> */}
        </div>
    )
}

export default StudentCardList




